import { render, staticRenderFns } from "./businessCard.vue?vue&type=template&id=3d9a6807&scoped=true&"
import script from "./businessCard.vue?vue&type=script&lang=js&"
export * from "./businessCard.vue?vue&type=script&lang=js&"
import style0 from "./businessCard.vue?vue&type=style&index=0&id=3d9a6807&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9a6807",
  null
  
)

export default component.exports